module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C369_6"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_List_of#page_xi"
    }
  }, [_vm._v("List of Tables and Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface#page_xiii"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowle#page_xix"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_PART_I_#page_1"
    }
  }, [_vm._v("PART I: BACKGROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1_War_an#page_3"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(". War and the American Presidency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1_War_an#id_1035"
    }
  }, [_vm._v("1.1. A Notion Expressed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1_War_an#id_1036"
    }
  }, [_vm._v("1.2. A Notion Evaluated")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1_War_an#id_1037"
    }
  }, [_vm._v("1.3. Sifting through the Claims")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1_War_an#id_1038"
    }
  }, [_vm._v("1.4. Quantitative Studies on War and Presidential Power")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1_War_an#id_1039"
    }
  }, [_vm._v("1.5. Moving Forward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_PART_II_#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: THEORIZING ABOUT INTERBRANCH BARGAINING DURING WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(". The Policy Priority Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1. Theoretical Building Blocks: Policies, Outcomes, and Interbranch Bargaining")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2. The Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3. Nontechnical Summary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_2_The_Po#id_1043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(". The Model’s Predictions about Modern U.S. Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1. Defining War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2. Which Equilibrium Are We Playing?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3. Measuring the Prioritization of National Outcomes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4. Characterizing the Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5. Key Expectations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6. Competing Explanations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_3_The_Mo#id_1049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.7. A Closing Note on Theory Testing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_PART_III#page_105",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: EMPIRICAL INVESTIGATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(". Spending in War and in Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1. Data")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2. Primary Analyses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3. Strategic Proposal Making")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4. Distinguishing between Two Theoretically Informed Causal Mechanisms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5. A Comment on Endogenous War Making")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_4_Spendi#id_1010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#page_142",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(". Voting in War and in Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.1. Data and Methods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.2. Post-9/11 Wars and the 107th Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.3. Earlier Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.4. World War I and the Relevance of Stateside Attacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.5. War and Other Crises")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_5_Voting#id_1016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.6. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_6_Case_S#page_182",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(". Case Studies I: Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_6_Case_S#id_1017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.1. The First Total War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_6_Case_S#id_1018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.2. Pearl Harbor and National Labor Policy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_6_Case_S#id_1019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.3. Roosevelt and All the Resplendence of a Wartime Presidency")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_6_Case_S#id_1020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.4. The Immigration Provisions of the USA PATRIOT Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_6_Case_S#id_1021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.5. Final Remarks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_7_Case_S#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(". Case Studies II: Challenges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_7_Case_S#id_1022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.1. The Federal Government Enters the Public Education Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_7_Case_S#id_1023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.2. The Great Society and the 1965 Decision to Send Ground Troops into Vietnam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_7_Case_S#id_1024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.3. Bush’s Wartime Effort to Reform Social Security")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_7_Case_S#id_1025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.4. Final Remarks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_PART_IV_#page_259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_8_Summar#page_261",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v(". Summaries, Speculations, and Extensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_8_Summar#id_1026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.1. Holes and Extensions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_8_Summar#id_1027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.2. The Future of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_8_Summar#id_1028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.3. A Future for the Policy Priority Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_PART_V_#page_273",
      "id": "page_ix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V: APPENDIXES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_A_Techni#page_275",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A")]), _vm._v(". Technical Details, Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_B_Altern#page_292",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B")]), _vm._v(". Alternative Bridging Criteria, Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_C_Summar#page_296",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C")]), _vm._v(". Summary Tables, Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#page_308",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("D")]), _vm._v(". Robustness Checks, Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.1. Alternative Estimation Procedures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.2. Alternative Interest Group Bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.3. Changes in the Agenda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#page_317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.4. Subsets of Roll Call Votes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.5. Defining the Beginning of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.6. Rising Conservatism and War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_D_Robust#id_1034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.7. Placebo Tests")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Bibliogr#page_323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Index#page_333",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0